module.exports = __webpack_public_path__ + "img/reportFE.061e6841.png";